import React from "react";
// replace \n to line break in FormattedMessage text
export const linesToParagraphs = (...nodes) => {
  return nodes
    .map(
      node =>
        typeof node === "string"
          ? node.split("\n").map((text, key) => (
            <span key={key}>
              {text}
              <br />
            </span>
          ))
          : node
    )
    .reduce((nodes, node) => nodes.concat(node), []);
}


// WEBPACK FOOTER //
// ./src/components/landing/common/Functions.js